import React from 'react'
import cn from 'classnames'
import styled from '@emotion/styled'
import { Form } from 'util/ui'
import { propFunc } from 'util/functions'
import { passwordRules } from 'util/validation'
import ValidatedField from 'shared/components/ui/ValidatedField'
import themeVars from 'ui_theme/site/globals/site.variables'

import Button from '../Button'
import PageHeader from '../PageHeader'

import sharedStyles from '../../sharedForm/styles.less'
import SaveIndicator from '../../sharedForm/SaveIndicator'

const Conditions = styled('ul')`
  column-count: 2;
  column-gap: ${themeVars.relative60px};
  padding-left: 0;
`

const Condition = styled('li')`
  opacity: ${props => (props.valid ? 0.25 : 1)};
  transition: opacity ${themeVars.defaultDuration} ${themeVars.defaultEasing};
  list-style: none;
  display: inline-block;
  padding: 0 0 ${props => props.theme.spacing['5']} 0;
  color: ${props => props.theme.color.monochrome.black};
  width: 200px;
  :before {
    font-size: ${themeVars['32px']};
    vertical-align: text-bottom;
    content: '\u2022';
    color: ${props => props.theme.color.primary.positive};
    margin-right: ${themeVars['8px']};
  }
`

class PasswordPage extends React.PureComponent {
  state = {
    conditions: {},
  }

  handleChange = (name, _, { value }) => {
    const { onChange } = this.props
    onChange(name, value, null, { validate: true })
    // NOTE (jscheel): Not worried about using the returned object here because
    // the passwordRules function is memoized anyways.
    this.setState({ conditions: passwordRules(value) })
  }

  render() {
    const { formFields, submitForm, canSave, saving } = this.props
    const { conditions } = this.state
    return (
      <React.Fragment>
        <PageHeader primary="Let's set up your password" />
        <Form
          size="large"
          className={cn(sharedStyles.form, sharedStyles.formV2)}
        >
          <Form.Field>
            <label htmlFor="password">Password</label>
            <ValidatedField
              placeholder="Enter 8 characters or more"
              type="password"
              name="password"
              value={formFields.password}
              onChange={propFunc(this.handleChange, 'password')}
              autoFocus
            />
          </Form.Field>
          <Form.Field>
            <Conditions>
              <Condition valid={conditions.lowercase}>
                One lowercase character
              </Condition>
              <Condition valid={conditions.uppercase}>
                One uppercase character
              </Condition>
              <Condition valid={conditions.number}>One number</Condition>
              <Condition valid={conditions.special}>
                One special character
              </Condition>
              <Condition valid={conditions.length}>
                8 characters minimum
              </Condition>
            </Conditions>
          </Form.Field>
          <Button disabled={!canSave} onClick={submitForm}>
            {!saving ? (
              'Continue'
            ) : (
              <SaveIndicator animate>Saving</SaveIndicator>
            )}
          </Button>
        </Form>
      </React.Fragment>
    )
  }
}

export default PasswordPage
